import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  GraphQLStringOrFloat: any;
  JSON: any;
};

export type Html_Content = {
  __typename?: 'Html_Content';
  content?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  has_border: Scalars['Boolean'];
  id: Scalars['ID'];
  margin_top?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type Html_Content_Aggregated = {
  __typename?: 'Html_Content_aggregated';
  avg?: Maybe<Html_Content_Aggregated_Fields>;
  avgDistinct?: Maybe<Html_Content_Aggregated_Fields>;
  count?: Maybe<Html_Content_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Html_Content_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Html_Content_Aggregated_Fields>;
  min?: Maybe<Html_Content_Aggregated_Fields>;
  sum?: Maybe<Html_Content_Aggregated_Fields>;
  sumDistinct?: Maybe<Html_Content_Aggregated_Fields>;
};

export type Html_Content_Aggregated_Count = {
  __typename?: 'Html_Content_aggregated_count';
  content?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  has_border?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  margin_top?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

export type Html_Content_Aggregated_Fields = {
  __typename?: 'Html_Content_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  margin_top?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Html_Content_Filter = {
  _and?: Maybe<Array<Maybe<Html_Content_Filter>>>;
  _or?: Maybe<Array<Maybe<Html_Content_Filter>>>;
  content?: Maybe<String_Filter_Operators>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  has_border?: Maybe<Boolean_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  margin_top?: Maybe<Number_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  uuid?: Maybe<String_Filter_Operators>;
};

export type Mutation = {
  __typename?: 'Mutation';
  create_event_item?: Maybe<Scalars['Boolean']>;
  create_event_items?: Maybe<Scalars['Boolean']>;
};


export type MutationCreate_Event_ItemArgs = {
  data: Create_Event_Input;
};


export type MutationCreate_Event_ItemsArgs = {
  data?: Maybe<Array<Create_Event_Input>>;
};

export type Page = {
  __typename?: 'Page';
  /** Override config partly or completely. If null the default config for the country will be used. */
  bv_react_client_config?: Maybe<Scalars['JSON']>;
  bv_react_client_config_func?: Maybe<Count_Functions>;
  context?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  elements?: Maybe<Array<Maybe<Page_Elements>>>;
  elements_func?: Maybe<Count_Functions>;
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  /** Note: The length of SERPs snippets should be not longer than 160 chars. It's not supported to add unicode symbols like a "checkmark". */
  meta_description?: Maybe<Scalars['String']>;
  meta_title?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type PageElementsArgs = {
  filter?: Maybe<Page_Elements_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Page_Aggregated = {
  __typename?: 'Page_aggregated';
  avg?: Maybe<Page_Aggregated_Fields>;
  avgDistinct?: Maybe<Page_Aggregated_Fields>;
  count?: Maybe<Page_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Page_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Page_Aggregated_Fields>;
  min?: Maybe<Page_Aggregated_Fields>;
  sum?: Maybe<Page_Aggregated_Fields>;
  sumDistinct?: Maybe<Page_Aggregated_Fields>;
};

export type Page_Aggregated_Count = {
  __typename?: 'Page_aggregated_count';
  /** Override config partly or completely. If null the default config for the country will be used. */
  bv_react_client_config?: Maybe<Scalars['Int']>;
  context?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  elements?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['Int']>;
  /** Note: The length of SERPs snippets should be not longer than 160 chars. It's not supported to add unicode symbols like a "checkmark". */
  meta_description?: Maybe<Scalars['Int']>;
  meta_title?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
};

export type Page_Aggregated_Fields = {
  __typename?: 'Page_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Page_Elements = {
  __typename?: 'Page_elements';
  Page_id?: Maybe<Page>;
  collection?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item?: Maybe<Page_Elements_Item_Union>;
  sort?: Maybe<Scalars['Int']>;
};


export type Page_ElementsPage_IdArgs = {
  filter?: Maybe<Page_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Page_Elements_Aggregated = {
  __typename?: 'Page_elements_aggregated';
  avg?: Maybe<Page_Elements_Aggregated_Fields>;
  avgDistinct?: Maybe<Page_Elements_Aggregated_Fields>;
  count?: Maybe<Page_Elements_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Page_Elements_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Page_Elements_Aggregated_Fields>;
  min?: Maybe<Page_Elements_Aggregated_Fields>;
  sum?: Maybe<Page_Elements_Aggregated_Fields>;
  sumDistinct?: Maybe<Page_Elements_Aggregated_Fields>;
};

export type Page_Elements_Aggregated_Count = {
  __typename?: 'Page_elements_aggregated_count';
  Page_id?: Maybe<Scalars['Int']>;
  collection?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  item?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
};

export type Page_Elements_Aggregated_Fields = {
  __typename?: 'Page_elements_aggregated_fields';
  Page_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Page_Elements_Filter = {
  Page_id?: Maybe<Page_Filter>;
  _and?: Maybe<Array<Maybe<Page_Elements_Filter>>>;
  _or?: Maybe<Array<Maybe<Page_Elements_Filter>>>;
  collection?: Maybe<String_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  item__Html_Content?: Maybe<Html_Content_Filter>;
  item__Price_Product_Query?: Maybe<Price_Product_Query_Filter>;
  item__Table_Content?: Maybe<Table_Content_Filter>;
  item__Two_Column_Content?: Maybe<Two_Column_Content_Filter>;
  sort?: Maybe<Number_Filter_Operators>;
};

export type Page_Elements_Item_Union = Html_Content | Price_Product_Query | Table_Content | Two_Column_Content;

export type Page_Filter = {
  _and?: Maybe<Array<Maybe<Page_Filter>>>;
  _or?: Maybe<Array<Maybe<Page_Filter>>>;
  bv_react_client_config?: Maybe<String_Filter_Operators>;
  bv_react_client_config_func?: Maybe<Count_Function_Filter_Operators>;
  context?: Maybe<String_Filter_Operators>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  elements?: Maybe<Page_Elements_Filter>;
  elements_func?: Maybe<Count_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  locale?: Maybe<String_Filter_Operators>;
  meta_description?: Maybe<String_Filter_Operators>;
  meta_title?: Maybe<String_Filter_Operators>;
  name?: Maybe<String_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  type?: Maybe<String_Filter_Operators>;
};

export type Price_Product_Query = {
  __typename?: 'Price_Product_Query';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  user_created?: Maybe<Scalars['String']>;
  user_updated?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type Price_Product_Query_Aggregated = {
  __typename?: 'Price_Product_Query_aggregated';
  avg?: Maybe<Price_Product_Query_Aggregated_Fields>;
  avgDistinct?: Maybe<Price_Product_Query_Aggregated_Fields>;
  count?: Maybe<Price_Product_Query_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Price_Product_Query_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Price_Product_Query_Aggregated_Fields>;
  min?: Maybe<Price_Product_Query_Aggregated_Fields>;
  sum?: Maybe<Price_Product_Query_Aggregated_Fields>;
  sumDistinct?: Maybe<Price_Product_Query_Aggregated_Fields>;
};

export type Price_Product_Query_Aggregated_Count = {
  __typename?: 'Price_Product_Query_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

export type Price_Product_Query_Aggregated_Fields = {
  __typename?: 'Price_Product_Query_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Price_Product_Query_Filter = {
  _and?: Maybe<Array<Maybe<Price_Product_Query_Filter>>>;
  _or?: Maybe<Array<Maybe<Price_Product_Query_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  user_created?: Maybe<String_Filter_Operators>;
  user_updated?: Maybe<String_Filter_Operators>;
  uuid?: Maybe<String_Filter_Operators>;
};

export type Query = {
  __typename?: 'Query';
  Html_Content: Array<Html_Content>;
  Html_Content_aggregated: Array<Html_Content_Aggregated>;
  Html_Content_by_id?: Maybe<Html_Content>;
  Page: Array<Page>;
  Page_aggregated: Array<Page_Aggregated>;
  Page_by_id?: Maybe<Page>;
  Page_elements: Array<Page_Elements>;
  Page_elements_aggregated: Array<Page_Elements_Aggregated>;
  Page_elements_by_id?: Maybe<Page_Elements>;
  Price_Product_Query: Array<Price_Product_Query>;
  Price_Product_Query_aggregated: Array<Price_Product_Query_Aggregated>;
  Price_Product_Query_by_id?: Maybe<Price_Product_Query>;
  Table_Content: Array<Table_Content>;
  Table_Content_aggregated: Array<Table_Content_Aggregated>;
  Table_Content_by_id?: Maybe<Table_Content>;
  Two_Column_Content: Array<Two_Column_Content>;
  Two_Column_Content_aggregated: Array<Two_Column_Content_Aggregated>;
  Two_Column_Content_by_id?: Maybe<Two_Column_Content>;
  brand: Array<Brand>;
  brand_aggregated: Array<Brand_Aggregated>;
  brand_by_id?: Maybe<Brand>;
  color: Array<Color>;
  color_aggregated: Array<Color_Aggregated>;
  color_by_id?: Maybe<Color>;
  color_translations: Array<Color_Translations>;
  color_translations_aggregated: Array<Color_Translations_Aggregated>;
  color_translations_by_id?: Maybe<Color_Translations>;
  languages: Array<Languages>;
  languages_aggregated: Array<Languages_Aggregated>;
  languages_by_id?: Maybe<Languages>;
  memory: Array<Memory>;
  memory_aggregated: Array<Memory_Aggregated>;
  memory_by_id?: Maybe<Memory>;
  partner: Array<Partner>;
  partner_aggregated: Array<Partner_Aggregated>;
  partner_by_id?: Maybe<Partner>;
  product: Array<Product>;
  product_aggregated: Array<Product_Aggregated>;
  product_by_id?: Maybe<Product>;
  product_phone_details: Array<Product_Phone_Details>;
  product_phone_details_aggregated: Array<Product_Phone_Details_Aggregated>;
  product_phone_details_by_id?: Maybe<Product_Phone_Details>;
  product_phone_product_details: Array<Product_Phone_Product_Details>;
  product_phone_product_details_aggregated: Array<Product_Phone_Product_Details_Aggregated>;
  product_phone_product_details_by_id?: Maybe<Product_Phone_Product_Details>;
  product_product_details: Array<Product_Product_Details>;
  product_product_details_aggregated: Array<Product_Product_Details_Aggregated>;
  product_product_details_by_id?: Maybe<Product_Product_Details>;
  screen_size: Array<Screen_Size>;
  screen_size_aggregated: Array<Screen_Size_Aggregated>;
  screen_size_by_id?: Maybe<Screen_Size>;
  weight: Array<Weight>;
  weight_aggregated: Array<Weight_Aggregated>;
  weight_by_id?: Maybe<Weight>;
};


export type QueryHtml_ContentArgs = {
  filter?: Maybe<Html_Content_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryHtml_Content_AggregatedArgs = {
  filter?: Maybe<Html_Content_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryHtml_Content_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPageArgs = {
  filter?: Maybe<Page_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPage_AggregatedArgs = {
  filter?: Maybe<Page_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPage_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPage_ElementsArgs = {
  filter?: Maybe<Page_Elements_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPage_Elements_AggregatedArgs = {
  filter?: Maybe<Page_Elements_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPage_Elements_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPrice_Product_QueryArgs = {
  filter?: Maybe<Price_Product_Query_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPrice_Product_Query_AggregatedArgs = {
  filter?: Maybe<Price_Product_Query_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPrice_Product_Query_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryTable_ContentArgs = {
  filter?: Maybe<Table_Content_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryTable_Content_AggregatedArgs = {
  filter?: Maybe<Table_Content_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryTable_Content_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryTwo_Column_ContentArgs = {
  filter?: Maybe<Two_Column_Content_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryTwo_Column_Content_AggregatedArgs = {
  filter?: Maybe<Two_Column_Content_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryTwo_Column_Content_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryBrandArgs = {
  filter?: Maybe<Brand_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryBrand_AggregatedArgs = {
  filter?: Maybe<Brand_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryBrand_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryColorArgs = {
  filter?: Maybe<Color_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryColor_AggregatedArgs = {
  filter?: Maybe<Color_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryColor_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryColor_TranslationsArgs = {
  filter?: Maybe<Color_Translations_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryColor_Translations_AggregatedArgs = {
  filter?: Maybe<Color_Translations_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryColor_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryLanguagesArgs = {
  filter?: Maybe<Languages_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryLanguages_AggregatedArgs = {
  filter?: Maybe<Languages_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryLanguages_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryMemoryArgs = {
  filter?: Maybe<Memory_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryMemory_AggregatedArgs = {
  filter?: Maybe<Memory_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryMemory_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPartnerArgs = {
  filter?: Maybe<Partner_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPartner_AggregatedArgs = {
  filter?: Maybe<Partner_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPartner_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProductArgs = {
  filter?: Maybe<Product_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_AggregatedArgs = {
  filter?: Maybe<Product_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Phone_DetailsArgs = {
  filter?: Maybe<Product_Phone_Details_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_Phone_Details_AggregatedArgs = {
  filter?: Maybe<Product_Phone_Details_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_Phone_Details_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Phone_Product_DetailsArgs = {
  filter?: Maybe<Product_Phone_Product_Details_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_Phone_Product_Details_AggregatedArgs = {
  filter?: Maybe<Product_Phone_Product_Details_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_Phone_Product_Details_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Product_DetailsArgs = {
  filter?: Maybe<Product_Product_Details_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_Product_Details_AggregatedArgs = {
  filter?: Maybe<Product_Product_Details_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryProduct_Product_Details_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryScreen_SizeArgs = {
  filter?: Maybe<Screen_Size_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryScreen_Size_AggregatedArgs = {
  filter?: Maybe<Screen_Size_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryScreen_Size_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryWeightArgs = {
  filter?: Maybe<Weight_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryWeight_AggregatedArgs = {
  filter?: Maybe<Weight_Filter>;
  groupBy?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryWeight_By_IdArgs = {
  id: Scalars['ID'];
};

export type Table_Content = {
  __typename?: 'Table_Content';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  header?: Maybe<Scalars['String']>;
  /** price: Price is queried for the externalId */
  headers?: Maybe<Scalars['JSON']>;
  headers_func?: Maybe<Count_Functions>;
  id: Scalars['ID'];
  margin_top?: Maybe<Scalars['Int']>;
  row_height?: Maybe<Scalars['Int']>;
  rows?: Maybe<Scalars['JSON']>;
  rows_func?: Maybe<Count_Functions>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  subheader?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type Table_Content_Aggregated = {
  __typename?: 'Table_Content_aggregated';
  avg?: Maybe<Table_Content_Aggregated_Fields>;
  avgDistinct?: Maybe<Table_Content_Aggregated_Fields>;
  count?: Maybe<Table_Content_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Table_Content_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Table_Content_Aggregated_Fields>;
  min?: Maybe<Table_Content_Aggregated_Fields>;
  sum?: Maybe<Table_Content_Aggregated_Fields>;
  sumDistinct?: Maybe<Table_Content_Aggregated_Fields>;
};

export type Table_Content_Aggregated_Count = {
  __typename?: 'Table_Content_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  header?: Maybe<Scalars['Int']>;
  /** price: Price is queried for the externalId */
  headers?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  margin_top?: Maybe<Scalars['Int']>;
  row_height?: Maybe<Scalars['Int']>;
  rows?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  subheader?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

export type Table_Content_Aggregated_Fields = {
  __typename?: 'Table_Content_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  margin_top?: Maybe<Scalars['Float']>;
  row_height?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Table_Content_Filter = {
  _and?: Maybe<Array<Maybe<Table_Content_Filter>>>;
  _or?: Maybe<Array<Maybe<Table_Content_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  header?: Maybe<String_Filter_Operators>;
  headers?: Maybe<String_Filter_Operators>;
  headers_func?: Maybe<Count_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  margin_top?: Maybe<Number_Filter_Operators>;
  row_height?: Maybe<Number_Filter_Operators>;
  rows?: Maybe<String_Filter_Operators>;
  rows_func?: Maybe<Count_Function_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  subheader?: Maybe<String_Filter_Operators>;
  uuid?: Maybe<String_Filter_Operators>;
};

export type Two_Column_Content = {
  __typename?: 'Two_Column_Content';
  content_left?: Maybe<Scalars['String']>;
  content_right?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  has_border: Scalars['Boolean'];
  header?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  margin_top?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type Two_Column_Content_Aggregated = {
  __typename?: 'Two_Column_Content_aggregated';
  avg?: Maybe<Two_Column_Content_Aggregated_Fields>;
  avgDistinct?: Maybe<Two_Column_Content_Aggregated_Fields>;
  count?: Maybe<Two_Column_Content_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Two_Column_Content_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Two_Column_Content_Aggregated_Fields>;
  min?: Maybe<Two_Column_Content_Aggregated_Fields>;
  sum?: Maybe<Two_Column_Content_Aggregated_Fields>;
  sumDistinct?: Maybe<Two_Column_Content_Aggregated_Fields>;
};

export type Two_Column_Content_Aggregated_Count = {
  __typename?: 'Two_Column_Content_aggregated_count';
  content_left?: Maybe<Scalars['Int']>;
  content_right?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  has_border?: Maybe<Scalars['Int']>;
  header?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  margin_top?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

export type Two_Column_Content_Aggregated_Fields = {
  __typename?: 'Two_Column_Content_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  margin_top?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Two_Column_Content_Filter = {
  _and?: Maybe<Array<Maybe<Two_Column_Content_Filter>>>;
  _or?: Maybe<Array<Maybe<Two_Column_Content_Filter>>>;
  content_left?: Maybe<String_Filter_Operators>;
  content_right?: Maybe<String_Filter_Operators>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  has_border?: Maybe<Boolean_Filter_Operators>;
  header?: Maybe<String_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  margin_top?: Maybe<Number_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  uuid?: Maybe<String_Filter_Operators>;
};

export type Boolean_Filter_Operators = {
  _eq?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nnull?: Maybe<Scalars['Boolean']>;
  _null?: Maybe<Scalars['Boolean']>;
};

export type Brand = {
  __typename?: 'brand';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  product?: Maybe<Array<Maybe<Product>>>;
  product_func?: Maybe<Count_Functions>;
  status?: Maybe<Scalars['String']>;
};


export type BrandProductArgs = {
  filter?: Maybe<Product_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Brand_Aggregated = {
  __typename?: 'brand_aggregated';
  avg?: Maybe<Brand_Aggregated_Fields>;
  avgDistinct?: Maybe<Brand_Aggregated_Fields>;
  count?: Maybe<Brand_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Brand_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Brand_Aggregated_Fields>;
  min?: Maybe<Brand_Aggregated_Fields>;
  sum?: Maybe<Brand_Aggregated_Fields>;
  sumDistinct?: Maybe<Brand_Aggregated_Fields>;
};

export type Brand_Aggregated_Count = {
  __typename?: 'brand_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  product?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type Brand_Aggregated_Fields = {
  __typename?: 'brand_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Brand_Filter = {
  _and?: Maybe<Array<Maybe<Brand_Filter>>>;
  _or?: Maybe<Array<Maybe<Brand_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  name?: Maybe<String_Filter_Operators>;
  product?: Maybe<Product_Filter>;
  product_func?: Maybe<Count_Function_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
};

export type Color = {
  __typename?: 'color';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Color_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  value?: Maybe<Scalars['String']>;
};


export type ColorTranslationsArgs = {
  filter?: Maybe<Color_Translations_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Color_Aggregated = {
  __typename?: 'color_aggregated';
  avg?: Maybe<Color_Aggregated_Fields>;
  avgDistinct?: Maybe<Color_Aggregated_Fields>;
  count?: Maybe<Color_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Color_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Color_Aggregated_Fields>;
  min?: Maybe<Color_Aggregated_Fields>;
  sum?: Maybe<Color_Aggregated_Fields>;
  sumDistinct?: Maybe<Color_Aggregated_Fields>;
};

export type Color_Aggregated_Count = {
  __typename?: 'color_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type Color_Aggregated_Fields = {
  __typename?: 'color_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Color_Filter = {
  _and?: Maybe<Array<Maybe<Color_Filter>>>;
  _or?: Maybe<Array<Maybe<Color_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  name?: Maybe<String_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  translations?: Maybe<Color_Translations_Filter>;
  translations_func?: Maybe<Count_Function_Filter_Operators>;
  value?: Maybe<String_Filter_Operators>;
};

export type Color_Translations = {
  __typename?: 'color_translations';
  color_id?: Maybe<Color>;
  id: Scalars['ID'];
  languages_id?: Maybe<Languages>;
  value?: Maybe<Scalars['String']>;
};


export type Color_TranslationsColor_IdArgs = {
  filter?: Maybe<Color_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type Color_TranslationsLanguages_IdArgs = {
  filter?: Maybe<Languages_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Color_Translations_Aggregated = {
  __typename?: 'color_translations_aggregated';
  avg?: Maybe<Color_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Color_Translations_Aggregated_Fields>;
  count?: Maybe<Color_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Color_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Color_Translations_Aggregated_Fields>;
  min?: Maybe<Color_Translations_Aggregated_Fields>;
  sum?: Maybe<Color_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Color_Translations_Aggregated_Fields>;
};

export type Color_Translations_Aggregated_Count = {
  __typename?: 'color_translations_aggregated_count';
  color_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  languages_id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type Color_Translations_Aggregated_Fields = {
  __typename?: 'color_translations_aggregated_fields';
  color_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Color_Translations_Filter = {
  _and?: Maybe<Array<Maybe<Color_Translations_Filter>>>;
  _or?: Maybe<Array<Maybe<Color_Translations_Filter>>>;
  color_id?: Maybe<Color_Filter>;
  id?: Maybe<Number_Filter_Operators>;
  languages_id?: Maybe<Languages_Filter>;
  value?: Maybe<String_Filter_Operators>;
};

export type Count_Function_Filter_Operators = {
  count?: Maybe<Number_Filter_Operators>;
};

export type Count_Functions = {
  __typename?: 'count_functions';
  count?: Maybe<Scalars['Int']>;
};

export type Create_Event_Input = {
  action: Scalars['String'];
  category: Scalars['String'];
  date_created?: Maybe<Scalars['Date']>;
  date_updated?: Maybe<Scalars['Date']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uuid?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Date_Filter_Operators = {
  _between?: Maybe<Array<Maybe<Scalars['GraphQLStringOrFloat']>>>;
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Maybe<Scalars['String']>>>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _nbetween?: Maybe<Array<Maybe<Scalars['GraphQLStringOrFloat']>>>;
  _neq?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  _nnull?: Maybe<Scalars['Boolean']>;
  _null?: Maybe<Scalars['Boolean']>;
};

export type Date_Function_Filter_Operators = {
  day?: Maybe<Number_Filter_Operators>;
  month?: Maybe<Number_Filter_Operators>;
  week?: Maybe<Number_Filter_Operators>;
  weekday?: Maybe<Number_Filter_Operators>;
  year?: Maybe<Number_Filter_Operators>;
};

export type Date_Functions = {
  __typename?: 'date_functions';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  week?: Maybe<Scalars['Int']>;
  weekday?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Datetime_Function_Filter_Operators = {
  day?: Maybe<Number_Filter_Operators>;
  hour?: Maybe<Number_Filter_Operators>;
  minute?: Maybe<Number_Filter_Operators>;
  month?: Maybe<Number_Filter_Operators>;
  second?: Maybe<Number_Filter_Operators>;
  week?: Maybe<Number_Filter_Operators>;
  weekday?: Maybe<Number_Filter_Operators>;
  year?: Maybe<Number_Filter_Operators>;
};

export type Datetime_Functions = {
  __typename?: 'datetime_functions';
  day?: Maybe<Scalars['Int']>;
  hour?: Maybe<Scalars['Int']>;
  minute?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  second?: Maybe<Scalars['Int']>;
  week?: Maybe<Scalars['Int']>;
  weekday?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Directus_Files = {
  __typename?: 'directus_files';
  charset?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  embed?: Maybe<Scalars['String']>;
  filename_disk?: Maybe<Scalars['String']>;
  filename_download: Scalars['String'];
  filesize?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  metadata_func?: Maybe<Count_Functions>;
  modified_by?: Maybe<Scalars['String']>;
  modified_on?: Maybe<Scalars['Date']>;
  modified_on_func?: Maybe<Datetime_Functions>;
  storage: Scalars['String'];
  tags?: Maybe<Scalars['JSON']>;
  tags_func?: Maybe<Count_Functions>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uploaded_by?: Maybe<Scalars['String']>;
  uploaded_on?: Maybe<Scalars['Date']>;
  uploaded_on_func?: Maybe<Datetime_Functions>;
  width?: Maybe<Scalars['Int']>;
};

export type Directus_Files_Filter = {
  _and?: Maybe<Array<Maybe<Directus_Files_Filter>>>;
  _or?: Maybe<Array<Maybe<Directus_Files_Filter>>>;
  charset?: Maybe<String_Filter_Operators>;
  description?: Maybe<String_Filter_Operators>;
  duration?: Maybe<Number_Filter_Operators>;
  embed?: Maybe<String_Filter_Operators>;
  filename_disk?: Maybe<String_Filter_Operators>;
  filename_download?: Maybe<String_Filter_Operators>;
  filesize?: Maybe<String_Filter_Operators>;
  folder?: Maybe<String_Filter_Operators>;
  height?: Maybe<Number_Filter_Operators>;
  id?: Maybe<String_Filter_Operators>;
  location?: Maybe<String_Filter_Operators>;
  metadata?: Maybe<String_Filter_Operators>;
  metadata_func?: Maybe<Count_Function_Filter_Operators>;
  modified_by?: Maybe<String_Filter_Operators>;
  modified_on?: Maybe<Date_Filter_Operators>;
  modified_on_func?: Maybe<Datetime_Function_Filter_Operators>;
  storage?: Maybe<String_Filter_Operators>;
  tags?: Maybe<String_Filter_Operators>;
  tags_func?: Maybe<Count_Function_Filter_Operators>;
  title?: Maybe<String_Filter_Operators>;
  type?: Maybe<String_Filter_Operators>;
  uploaded_by?: Maybe<String_Filter_Operators>;
  uploaded_on?: Maybe<Date_Filter_Operators>;
  uploaded_on_func?: Maybe<Datetime_Function_Filter_Operators>;
  width?: Maybe<Number_Filter_Operators>;
};

export type Languages = {
  __typename?: 'languages';
  code: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type Languages_Aggregated = {
  __typename?: 'languages_aggregated';
  count?: Maybe<Languages_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Languages_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
};

export type Languages_Aggregated_Count = {
  __typename?: 'languages_aggregated_count';
  code?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
};

export type Languages_Filter = {
  _and?: Maybe<Array<Maybe<Languages_Filter>>>;
  _or?: Maybe<Array<Maybe<Languages_Filter>>>;
  code?: Maybe<String_Filter_Operators>;
  name?: Maybe<String_Filter_Operators>;
};

export type Memory = {
  __typename?: 'memory';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  product_phone_details?: Maybe<Array<Maybe<Product_Phone_Details>>>;
  product_phone_details_func?: Maybe<Count_Functions>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};


export type MemoryProduct_Phone_DetailsArgs = {
  filter?: Maybe<Product_Phone_Details_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Memory_Aggregated = {
  __typename?: 'memory_aggregated';
  avg?: Maybe<Memory_Aggregated_Fields>;
  avgDistinct?: Maybe<Memory_Aggregated_Fields>;
  count?: Maybe<Memory_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Memory_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Memory_Aggregated_Fields>;
  min?: Maybe<Memory_Aggregated_Fields>;
  sum?: Maybe<Memory_Aggregated_Fields>;
  sumDistinct?: Maybe<Memory_Aggregated_Fields>;
};

export type Memory_Aggregated_Count = {
  __typename?: 'memory_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  product_phone_details?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  unit?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type Memory_Aggregated_Fields = {
  __typename?: 'memory_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type Memory_Filter = {
  _and?: Maybe<Array<Maybe<Memory_Filter>>>;
  _or?: Maybe<Array<Maybe<Memory_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  product_phone_details?: Maybe<Product_Phone_Details_Filter>;
  product_phone_details_func?: Maybe<Count_Function_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  unit?: Maybe<String_Filter_Operators>;
  value?: Maybe<Number_Filter_Operators>;
};

export type Number_Filter_Operators = {
  _between?: Maybe<Array<Maybe<Scalars['GraphQLStringOrFloat']>>>;
  _eq?: Maybe<Scalars['GraphQLStringOrFloat']>;
  _gt?: Maybe<Scalars['GraphQLStringOrFloat']>;
  _gte?: Maybe<Scalars['GraphQLStringOrFloat']>;
  _in?: Maybe<Array<Maybe<Scalars['GraphQLStringOrFloat']>>>;
  _lt?: Maybe<Scalars['GraphQLStringOrFloat']>;
  _lte?: Maybe<Scalars['GraphQLStringOrFloat']>;
  _nbetween?: Maybe<Array<Maybe<Scalars['GraphQLStringOrFloat']>>>;
  _neq?: Maybe<Scalars['GraphQLStringOrFloat']>;
  _nin?: Maybe<Array<Maybe<Scalars['GraphQLStringOrFloat']>>>;
  _nnull?: Maybe<Scalars['Boolean']>;
  _null?: Maybe<Scalars['Boolean']>;
};

export type Partner = {
  __typename?: 'partner';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

export type Partner_Aggregated = {
  __typename?: 'partner_aggregated';
  avg?: Maybe<Partner_Aggregated_Fields>;
  avgDistinct?: Maybe<Partner_Aggregated_Fields>;
  count?: Maybe<Partner_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Partner_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Partner_Aggregated_Fields>;
  min?: Maybe<Partner_Aggregated_Fields>;
  sum?: Maybe<Partner_Aggregated_Fields>;
  sumDistinct?: Maybe<Partner_Aggregated_Fields>;
};

export type Partner_Aggregated_Count = {
  __typename?: 'partner_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['Int']>;
};

export type Partner_Aggregated_Fields = {
  __typename?: 'partner_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Partner_Filter = {
  _and?: Maybe<Array<Maybe<Partner_Filter>>>;
  _or?: Maybe<Array<Maybe<Partner_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  name?: Maybe<String_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  uuid?: Maybe<String_Filter_Operators>;
};

export type Product = {
  __typename?: 'product';
  brand?: Maybe<Brand>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  image?: Maybe<Directus_Files>;
  name?: Maybe<Scalars['String']>;
  product_details?: Maybe<Array<Maybe<Product_Product_Details>>>;
  product_details_func?: Maybe<Count_Functions>;
  release_date?: Maybe<Scalars['Date']>;
  release_date_func?: Maybe<Date_Functions>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  weight?: Maybe<Weight>;
};


export type ProductBrandArgs = {
  filter?: Maybe<Brand_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ProductImageArgs = {
  filter?: Maybe<Directus_Files_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ProductProduct_DetailsArgs = {
  filter?: Maybe<Product_Product_Details_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type ProductWeightArgs = {
  filter?: Maybe<Weight_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Product_Aggregated = {
  __typename?: 'product_aggregated';
  avg?: Maybe<Product_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Aggregated_Fields>;
  count?: Maybe<Product_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Aggregated_Fields>;
  min?: Maybe<Product_Aggregated_Fields>;
  sum?: Maybe<Product_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Aggregated_Fields>;
};

export type Product_Aggregated_Count = {
  __typename?: 'product_aggregated_count';
  brand?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  product_details?: Maybe<Scalars['Int']>;
  release_date?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  weight?: Maybe<Scalars['Int']>;
};

export type Product_Aggregated_Fields = {
  __typename?: 'product_aggregated_fields';
  brand?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type Product_Filter = {
  _and?: Maybe<Array<Maybe<Product_Filter>>>;
  _or?: Maybe<Array<Maybe<Product_Filter>>>;
  brand?: Maybe<Brand_Filter>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  image?: Maybe<Directus_Files_Filter>;
  name?: Maybe<String_Filter_Operators>;
  product_details?: Maybe<Product_Product_Details_Filter>;
  product_details_func?: Maybe<Count_Function_Filter_Operators>;
  release_date?: Maybe<Date_Filter_Operators>;
  release_date_func?: Maybe<Date_Function_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  weight?: Maybe<Weight_Filter>;
};

export type Product_Phone_Details = {
  __typename?: 'product_phone_details';
  color?: Maybe<Color>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  image?: Maybe<Directus_Files>;
  memory?: Maybe<Memory>;
  screen_size?: Maybe<Screen_Size>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};


export type Product_Phone_DetailsColorArgs = {
  filter?: Maybe<Color_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type Product_Phone_DetailsImageArgs = {
  filter?: Maybe<Directus_Files_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type Product_Phone_DetailsMemoryArgs = {
  filter?: Maybe<Memory_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type Product_Phone_DetailsScreen_SizeArgs = {
  filter?: Maybe<Screen_Size_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Product_Phone_Details_Aggregated = {
  __typename?: 'product_phone_details_aggregated';
  avg?: Maybe<Product_Phone_Details_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Phone_Details_Aggregated_Fields>;
  count?: Maybe<Product_Phone_Details_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Phone_Details_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Phone_Details_Aggregated_Fields>;
  min?: Maybe<Product_Phone_Details_Aggregated_Fields>;
  sum?: Maybe<Product_Phone_Details_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Phone_Details_Aggregated_Fields>;
};

export type Product_Phone_Details_Aggregated_Count = {
  __typename?: 'product_phone_details_aggregated_count';
  color?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['Int']>;
  memory?: Maybe<Scalars['Int']>;
  screen_size?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type Product_Phone_Details_Aggregated_Fields = {
  __typename?: 'product_phone_details_aggregated_fields';
  color?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  memory?: Maybe<Scalars['Float']>;
  screen_size?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Product_Phone_Details_Filter = {
  _and?: Maybe<Array<Maybe<Product_Phone_Details_Filter>>>;
  _or?: Maybe<Array<Maybe<Product_Phone_Details_Filter>>>;
  color?: Maybe<Color_Filter>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  image?: Maybe<Directus_Files_Filter>;
  memory?: Maybe<Memory_Filter>;
  screen_size?: Maybe<Screen_Size_Filter>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
};

export type Product_Phone_Product_Details = {
  __typename?: 'product_phone_product_details';
  collection?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item?: Maybe<Product_Phone_Product_Details_Item_Union>;
};

export type Product_Phone_Product_Details_Aggregated = {
  __typename?: 'product_phone_product_details_aggregated';
  avg?: Maybe<Product_Phone_Product_Details_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Phone_Product_Details_Aggregated_Fields>;
  count?: Maybe<Product_Phone_Product_Details_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Phone_Product_Details_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Phone_Product_Details_Aggregated_Fields>;
  min?: Maybe<Product_Phone_Product_Details_Aggregated_Fields>;
  sum?: Maybe<Product_Phone_Product_Details_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Phone_Product_Details_Aggregated_Fields>;
};

export type Product_Phone_Product_Details_Aggregated_Count = {
  __typename?: 'product_phone_product_details_aggregated_count';
  collection?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  item?: Maybe<Scalars['Int']>;
};

export type Product_Phone_Product_Details_Aggregated_Fields = {
  __typename?: 'product_phone_product_details_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Product_Phone_Product_Details_Filter = {
  _and?: Maybe<Array<Maybe<Product_Phone_Product_Details_Filter>>>;
  _or?: Maybe<Array<Maybe<Product_Phone_Product_Details_Filter>>>;
  collection?: Maybe<String_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  item__product_phone_details?: Maybe<Product_Phone_Details_Filter>;
};

export type Product_Phone_Product_Details_Item_Union = Product_Phone_Details;

export type Product_Product_Details = {
  __typename?: 'product_product_details';
  collection?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item?: Maybe<Product_Product_Details_Item_Union>;
  product_id?: Maybe<Product>;
};


export type Product_Product_DetailsProduct_IdArgs = {
  filter?: Maybe<Product_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Product_Product_Details_Aggregated = {
  __typename?: 'product_product_details_aggregated';
  avg?: Maybe<Product_Product_Details_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Product_Details_Aggregated_Fields>;
  count?: Maybe<Product_Product_Details_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Product_Details_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Product_Details_Aggregated_Fields>;
  min?: Maybe<Product_Product_Details_Aggregated_Fields>;
  sum?: Maybe<Product_Product_Details_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Product_Details_Aggregated_Fields>;
};

export type Product_Product_Details_Aggregated_Count = {
  __typename?: 'product_product_details_aggregated_count';
  collection?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  item?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
};

export type Product_Product_Details_Aggregated_Fields = {
  __typename?: 'product_product_details_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  product_id?: Maybe<Scalars['Float']>;
};

export type Product_Product_Details_Filter = {
  _and?: Maybe<Array<Maybe<Product_Product_Details_Filter>>>;
  _or?: Maybe<Array<Maybe<Product_Product_Details_Filter>>>;
  collection?: Maybe<String_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  item__product_phone_details?: Maybe<Product_Phone_Details_Filter>;
  product_id?: Maybe<Product_Filter>;
};

export type Product_Product_Details_Item_Union = Product_Phone_Details;

export type Screen_Size = {
  __typename?: 'screen_size';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  product_phone_details?: Maybe<Array<Maybe<Product_Phone_Details>>>;
  product_phone_details_func?: Maybe<Count_Functions>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};


export type Screen_SizeProduct_Phone_DetailsArgs = {
  filter?: Maybe<Product_Phone_Details_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Screen_Size_Aggregated = {
  __typename?: 'screen_size_aggregated';
  avg?: Maybe<Screen_Size_Aggregated_Fields>;
  avgDistinct?: Maybe<Screen_Size_Aggregated_Fields>;
  count?: Maybe<Screen_Size_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Screen_Size_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Screen_Size_Aggregated_Fields>;
  min?: Maybe<Screen_Size_Aggregated_Fields>;
  sum?: Maybe<Screen_Size_Aggregated_Fields>;
  sumDistinct?: Maybe<Screen_Size_Aggregated_Fields>;
};

export type Screen_Size_Aggregated_Count = {
  __typename?: 'screen_size_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  product_phone_details?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  unit?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type Screen_Size_Aggregated_Fields = {
  __typename?: 'screen_size_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type Screen_Size_Filter = {
  _and?: Maybe<Array<Maybe<Screen_Size_Filter>>>;
  _or?: Maybe<Array<Maybe<Screen_Size_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  product_phone_details?: Maybe<Product_Phone_Details_Filter>;
  product_phone_details_func?: Maybe<Count_Function_Filter_Operators>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  unit?: Maybe<String_Filter_Operators>;
  value?: Maybe<Number_Filter_Operators>;
};

export type String_Filter_Operators = {
  _contains?: Maybe<Scalars['String']>;
  _empty?: Maybe<Scalars['Boolean']>;
  _ends_with?: Maybe<Scalars['String']>;
  _eq?: Maybe<Scalars['String']>;
  _icontains?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Maybe<Scalars['String']>>>;
  _ncontains?: Maybe<Scalars['String']>;
  _nempty?: Maybe<Scalars['Boolean']>;
  _nends_with?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Maybe<Scalars['String']>>>;
  _nnull?: Maybe<Scalars['Boolean']>;
  _nstarts_with?: Maybe<Scalars['String']>;
  _null?: Maybe<Scalars['Boolean']>;
  _starts_with?: Maybe<Scalars['String']>;
};

export type Weight = {
  __typename?: 'weight';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  product?: Maybe<Array<Maybe<Product>>>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};


export type WeightProductArgs = {
  filter?: Maybe<Product_Filter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  sort?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Weight_Aggregated = {
  __typename?: 'weight_aggregated';
  avg?: Maybe<Weight_Aggregated_Fields>;
  avgDistinct?: Maybe<Weight_Aggregated_Fields>;
  count?: Maybe<Weight_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Weight_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Weight_Aggregated_Fields>;
  min?: Maybe<Weight_Aggregated_Fields>;
  sum?: Maybe<Weight_Aggregated_Fields>;
  sumDistinct?: Maybe<Weight_Aggregated_Fields>;
};

export type Weight_Aggregated_Count = {
  __typename?: 'weight_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  unit?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type Weight_Aggregated_Fields = {
  __typename?: 'weight_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type Weight_Filter = {
  _and?: Maybe<Array<Maybe<Weight_Filter>>>;
  _or?: Maybe<Array<Maybe<Weight_Filter>>>;
  date_created?: Maybe<Date_Filter_Operators>;
  date_created_func?: Maybe<Datetime_Function_Filter_Operators>;
  date_updated?: Maybe<Date_Filter_Operators>;
  date_updated_func?: Maybe<Datetime_Function_Filter_Operators>;
  id?: Maybe<Number_Filter_Operators>;
  product?: Maybe<Product_Filter>;
  sort?: Maybe<Number_Filter_Operators>;
  status?: Maybe<String_Filter_Operators>;
  unit?: Maybe<String_Filter_Operators>;
  value?: Maybe<Number_Filter_Operators>;
};

export type SearchProductsQueryVariables = Exact<{
  search_term: Scalars['String'];
  limit: Scalars['Int'];
}>;


export type SearchProductsQuery = { __typename?: 'Query', product: Array<{ __typename?: 'product', id: string, name?: string | null, product_details?: Array<{ __typename?: 'product_product_details', id: string } | null> | null }> };

export type GetAllProductVariantsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetAllProductVariantsQuery = { __typename?: 'Query', product: Array<{ __typename?: 'product', id: string, name?: string | null, release_date?: any | null, brand?: { __typename?: 'brand', name?: string | null } | null, weight?: { __typename?: 'weight', id: string, value?: number | null, unit?: string | null } | null, product_details?: Array<{ __typename?: 'product_product_details', id: string, collection?: string | null, item?: { __typename: 'product_phone_details', id: string, color?: { __typename?: 'color', sort?: number | null, name?: string | null, translations?: Array<{ __typename?: 'color_translations', value?: string | null, languages_id?: { __typename?: 'languages', code: string } | null } | null> | null } | null, memory?: { __typename?: 'memory', id: string, sort?: number | null, value?: number | null, unit?: string | null } | null, screen_size?: { __typename?: 'screen_size', value?: number | null, unit?: string | null } | null } | null } | null> | null }> };

export type GetProductByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductByIdQuery = { __typename?: 'Query', product_by_id?: { __typename?: 'product', id: string, name?: string | null, release_date?: any | null, brand?: { __typename?: 'brand', id: string, name?: string | null } | null, weight?: { __typename?: 'weight', id: string, value?: number | null, unit?: string | null } | null, product_details?: Array<{ __typename?: 'product_product_details', id: string, collection?: string | null, item?: { __typename: 'product_phone_details', id: string, image?: { __typename?: 'directus_files', id: string } | null, color?: { __typename?: 'color', id: string, sort?: number | null, value?: string | null, translations?: Array<{ __typename?: 'color_translations', value?: string | null, languages_id?: { __typename?: 'languages', code: string } | null } | null> | null } | null, memory?: { __typename?: 'memory', id: string, sort?: number | null, value?: number | null, unit?: string | null } | null, screen_size?: { __typename?: 'screen_size', value?: number | null, unit?: string | null } | null } | null } | null> | null } | null };

export type GetProductDetailsByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductDetailsByIdQuery = { __typename?: 'Query', product_product_details_by_id?: { __typename?: 'product_product_details', product_id?: { __typename?: 'product', id: string } | null } | null };

export type GetAllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProductsQuery = { __typename?: 'Query', product: Array<{ __typename?: 'product', id: string, name?: string | null, release_date?: any | null, image?: { __typename?: 'directus_files', id: string } | null, product_details?: Array<{ __typename?: 'product_product_details', id: string } | null> | null }> };

export type GetAllPagesByCategoryQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetAllPagesByCategoryQuery = { __typename?: 'Query', Page: Array<{ __typename?: 'Page', type?: string | null, status?: string | null, locale?: string | null, context?: string | null, name?: string | null, meta_title?: string | null, meta_description?: string | null, bv_react_client_config?: any | null, elements?: Array<{ __typename?: 'Page_elements', item?: { __typename: 'Html_Content', id: string, uuid?: string | null, margin_top?: number | null, has_border: boolean, content?: string | null } | { __typename: 'Price_Product_Query', id: string, uuid?: string | null } | { __typename: 'Table_Content', id: string, uuid?: string | null, margin_top?: number | null, row_height?: number | null, header?: string | null, subheader?: string | null, headers?: any | null, rows?: any | null } | { __typename: 'Two_Column_Content', id: string, uuid?: string | null, margin_top?: number | null, has_border: boolean, header?: string | null, content_left?: string | null, content_right?: string | null } | null } | null> | null }> };

export type GetPageByNameContextLocaleQueryVariables = Exact<{
  name: Scalars['String'];
  context: Scalars['String'];
  locale: Scalars['String'];
}>;


export type GetPageByNameContextLocaleQuery = { __typename?: 'Query', Page: Array<{ __typename?: 'Page', type?: string | null, status?: string | null, locale?: string | null, context?: string | null, meta_title?: string | null, meta_description?: string | null, bv_react_client_config?: any | null, elements?: Array<{ __typename?: 'Page_elements', item?: { __typename: 'Html_Content', id: string, uuid?: string | null, margin_top?: number | null, content?: string | null, has_border: boolean } | { __typename: 'Price_Product_Query', id: string, uuid?: string | null } | { __typename: 'Table_Content', id: string, uuid?: string | null, margin_top?: number | null, row_height?: number | null, header?: string | null, headers?: any | null, rows?: any | null } | { __typename: 'Two_Column_Content', id: string, uuid?: string | null, margin_top?: number | null, has_border: boolean, header?: string | null, content_left?: string | null, content_right?: string | null } | null } | null> | null }> };


export const SearchProductsDocument = `
    query searchProducts($search_term: String!, $limit: Int!) {
  product(
    search: $search_term
    limit: $limit
    sort: ["-release_date"]
    filter: {status: {_eq: "published"}}
  ) {
    id
    name
    product_details {
      id
    }
  }
}
    `;
export const useSearchProductsQuery = <
      TData = SearchProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: SearchProductsQueryVariables,
      options?: UseQueryOptions<SearchProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SearchProductsQuery, TError, TData>(
      ['searchProducts', variables],
      fetcher<SearchProductsQuery, SearchProductsQueryVariables>(client, SearchProductsDocument, variables, headers),
      options
    );
export const GetAllProductVariantsDocument = `
    query getAllProductVariants($limit: Int!, $offset: Int!) {
  product(
    limit: $limit
    offset: $offset
    filter: {status: {_eq: "published"}}
    sort: ["release_date"]
  ) {
    id
    name
    brand {
      name
    }
    weight {
      id
      value
      unit
    }
    release_date
    product_details {
      id
      collection
      item {
        __typename
        ... on product_phone_details {
          id
          color {
            sort
            name
            translations {
              languages_id {
                code
              }
              value
            }
          }
          memory {
            id
            sort
            value
            unit
          }
          screen_size {
            value
            unit
          }
        }
      }
    }
  }
}
    `;
export const useGetAllProductVariantsQuery = <
      TData = GetAllProductVariantsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllProductVariantsQueryVariables,
      options?: UseQueryOptions<GetAllProductVariantsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllProductVariantsQuery, TError, TData>(
      ['getAllProductVariants', variables],
      fetcher<GetAllProductVariantsQuery, GetAllProductVariantsQueryVariables>(client, GetAllProductVariantsDocument, variables, headers),
      options
    );
export const GetProductByIdDocument = `
    query getProductById($id: ID!) {
  product_by_id(id: $id) {
    id
    name
    brand {
      id
      name
    }
    release_date
    weight {
      id
      value
      unit
    }
    product_details {
      id
      collection
      item {
        __typename
        ... on product_phone_details {
          id
          image {
            id
          }
          color {
            id
            sort
            value
            translations {
              languages_id {
                code
              }
              value
            }
          }
          memory {
            id
            sort
            value
            unit
          }
          screen_size {
            value
            unit
          }
        }
      }
    }
  }
}
    `;
export const useGetProductByIdQuery = <
      TData = GetProductByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetProductByIdQueryVariables,
      options?: UseQueryOptions<GetProductByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductByIdQuery, TError, TData>(
      ['getProductById', variables],
      fetcher<GetProductByIdQuery, GetProductByIdQueryVariables>(client, GetProductByIdDocument, variables, headers),
      options
    );
export const GetProductDetailsByIdDocument = `
    query getProductDetailsById($id: ID!) {
  product_product_details_by_id(id: $id) {
    product_id {
      id
    }
  }
}
    `;
export const useGetProductDetailsByIdQuery = <
      TData = GetProductDetailsByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetProductDetailsByIdQueryVariables,
      options?: UseQueryOptions<GetProductDetailsByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductDetailsByIdQuery, TError, TData>(
      ['getProductDetailsById', variables],
      fetcher<GetProductDetailsByIdQuery, GetProductDetailsByIdQueryVariables>(client, GetProductDetailsByIdDocument, variables, headers),
      options
    );
export const GetAllProductsDocument = `
    query getAllProducts {
  product(filter: {status: {_eq: "published"}}, sort: ["release_date"]) {
    id
    name
    release_date
    image {
      id
    }
    product_details {
      id
    }
  }
}
    `;
export const useGetAllProductsQuery = <
      TData = GetAllProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetAllProductsQueryVariables,
      options?: UseQueryOptions<GetAllProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllProductsQuery, TError, TData>(
      variables === undefined ? ['getAllProducts'] : ['getAllProducts', variables],
      fetcher<GetAllProductsQuery, GetAllProductsQueryVariables>(client, GetAllProductsDocument, variables, headers),
      options
    );
export const GetAllPagesByCategoryDocument = `
    query getAllPagesByCategory($type: String!) {
  Page(filter: {_and: [{status: {_eq: "published"}}, {type: {_eq: $type}}]}) {
    type
    status
    locale
    context
    name
    meta_title
    meta_description
    bv_react_client_config
    elements(sort: "sort") {
      item {
        __typename
        ... on Html_Content {
          id
          uuid
          margin_top
          has_border
          content
        }
        ... on Two_Column_Content {
          id
          uuid
          margin_top
          has_border
          header
          content_left
          content_right
        }
        ... on Table_Content {
          id
          uuid
          margin_top
          row_height
          header
          subheader
          headers
          rows
        }
        ... on Price_Product_Query {
          id
          uuid
        }
      }
    }
  }
}
    `;
export const useGetAllPagesByCategoryQuery = <
      TData = GetAllPagesByCategoryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetAllPagesByCategoryQueryVariables,
      options?: UseQueryOptions<GetAllPagesByCategoryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetAllPagesByCategoryQuery, TError, TData>(
      ['getAllPagesByCategory', variables],
      fetcher<GetAllPagesByCategoryQuery, GetAllPagesByCategoryQueryVariables>(client, GetAllPagesByCategoryDocument, variables, headers),
      options
    );
export const GetPageByNameContextLocaleDocument = `
    query getPageByNameContextLocale($name: String!, $context: String!, $locale: String!) {
  Page(
    filter: {_and: [{status: {_eq: "published"}}, {name: {_eq: $name}}, {context: {_eq: $context}}, {locale: {_eq: $locale}}]}
  ) {
    type
    status
    locale
    context
    meta_title
    meta_description
    bv_react_client_config
    elements(sort: "sort") {
      item {
        __typename
        ... on Html_Content {
          id
          uuid
          margin_top
          content
          has_border
        }
        ... on Two_Column_Content {
          id
          uuid
          margin_top
          has_border
          header
          content_left
          content_right
        }
        ... on Table_Content {
          id
          uuid
          margin_top
          row_height
          header
          headers
          rows
        }
        ... on Price_Product_Query {
          id
          uuid
        }
      }
    }
  }
}
    `;
export const useGetPageByNameContextLocaleQuery = <
      TData = GetPageByNameContextLocaleQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetPageByNameContextLocaleQueryVariables,
      options?: UseQueryOptions<GetPageByNameContextLocaleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetPageByNameContextLocaleQuery, TError, TData>(
      ['getPageByNameContextLocale', variables],
      fetcher<GetPageByNameContextLocaleQuery, GetPageByNameContextLocaleQueryVariables>(client, GetPageByNameContextLocaleDocument, variables, headers),
      options
    );